import { ClientInfoActionTypes } from "../../action-types";

const clientInfo= JSON.parse(localStorage.getItem("clientInfo"));

const initialState = {
  clientInfo: clientInfo ? clientInfo : null
};

export default function clientInfoReducer(state = initialState, action) {
  switch (action.type) {
    case ClientInfoActionTypes.CLIENT_INFO:
      return {
        clientInfo: action.payload,
      };
    case ClientInfoActionTypes.ADD_CLIENT_CRYOTO_ACCOUNTS:
      return {
        clientInfo: {...clientInfo, crypto_accounts: action.payload},
      };
    case ClientInfoActionTypes.ADD_CLIENT_FIAT_ACCOUNTS:
      return {
        clientInfo: {...clientInfo, accounts: action.payload},
      };
    case ClientInfoActionTypes.UPDATE_ACCOUNTS_BALANCES: {
      // Payload can be a single updated account object OR an array of updated accounts
      const updatedAccounts = Array.isArray(action.payload) ? action.payload : [action.payload];

      // Create a fast lookup map of updated balances by account ID
      const balanceMap = new Map(updatedAccounts.map((item) => [item.id, item.balance]));

      return {
        ...state,
        clientInfo: {
          ...(state.clientInfo ?? {}),
          accounts: (state.clientInfo?.accounts ?? []).map((account) => {
            // If this account has a new balance in the payload, update only balance
            if (balanceMap.has(account.id)) {
              return {
                ...account,
                balance: balanceMap.get(account.id),
              };
            }
            return account;
          }),
        },
      };
    }
    default:
      return state;
  }
}
